import React, { useState } from 'react';
import { setConsent, getConsent } from './consentStore';
import './CookieBanner.css';

export default function CookieBanner({ onDismiss, showDismiss }) {
  const [showDetails, setShowDetails] = useState(false);
  
  // If they already have a saved preference, initialize the toggle to match it.
  // Otherwise, default to true.
  const currentConsent = getConsent();
  const [analyticsEnabled, setAnalyticsEnabled] = useState(
    currentConsent ? currentConsent.analytics : true
  );

  const handleAcceptAll = () => {
    setConsent({ analytics: true });
    if (onDismiss) onDismiss();
  };

  const handleRejectAll = () => {
    setConsent({ analytics: false });
    if (onDismiss) onDismiss();
  };

  const handleSavePreferences = () => {
    setConsent({ analytics: analyticsEnabled });
    if (onDismiss) onDismiss();
  };

  return (
    <div className="pc-root" role="dialog" aria-modal="true" aria-labelledby="pc-title">
      <div className="pc-panel" tabIndex="-1">
        {showDismiss && (
          <button 
            className="pc-dismiss" 
            onClick={onDismiss} 
            aria-label="Close banner"
            title="Close"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        )}
        <div className="pc-main">
          <div className="pc-copy">
            <h2 id="pc-title" className="pc-title">We value your privacy</h2>
            <p className="pc-body">
              We use strictly necessary cookies to make our site work. With your permission, optional analytics include Microsoft Clarity heatmaps and privacy-masked session recordings so we can improve Promptera.
            </p>
            
            <button 
              className="pc-toggle" 
              onClick={() => setShowDetails(!showDetails)}
              aria-expanded={showDetails}
            >
              <span>{showDetails ? 'Hide preferences' : 'Manage preferences'}</span>
              <span className={`pc-chev ${showDetails ? 'is-open' : ''}`}></span>
            </button>
          </div>

          <div className="pc-actions">
            <button className="pc-btn pc-btn--ghost" onClick={handleRejectAll}>
              Reject optional
            </button>
            <button className="pc-btn pc-btn--solid" onClick={handleAcceptAll}>
              Accept analytics
            </button>
          </div>
        </div>

        {showDetails && (
          <div className="pc-details">
            <div className="pc-row">
              <div className="pc-row-text">
                <div className="pc-row-name">
                  Strictly Necessary
                  <span className="pc-tag">Always Active</span>
                </div>
                <div className="pc-row-desc">
                  These cookies are essential for the website to function properly. They cannot be disabled.
                </div>
              </div>
            </div>
            
            <div className="pc-row">
              <div className="pc-row-text">
                <div className="pc-row-name">
                  Analytics
                </div>
                <div className="pc-row-desc">
                  These cookies help us understand how visitors interact with the website. Clarity heatmaps and session recordings run only after you opt in; advertising storage stays disabled.
                </div>
              </div>
              <button 
                className={`pc-switch ${analyticsEnabled ? 'is-on' : ''}`}
                role="switch"
                aria-checked={analyticsEnabled}
                aria-label="Toggle Analytics Cookies"
                onClick={() => setAnalyticsEnabled(!analyticsEnabled)}
              >
                <span className="pc-switch-knob"></span>
              </button>
            </div>

            <div className="pc-details-actions">
              <button className="pc-btn pc-btn--ghost pc-btn--sm" onClick={handleSavePreferences}>
                Save preferences
              </button>
            </div>
          </div>
        )}

        <div className="pc-foot">
          For more information, please read our <a href="/privacy">Privacy Policy</a>.
        </div>
      </div>
    </div>
  );
}
